export default "__VITE_ASSET__Cny4lHMk__"